import { render, staticRenderFns } from "./MoreGame.vue?vue&type=template&id=2d398fa8&scoped=true"
import script from "./MoreGame.vue?vue&type=script&lang=js"
export * from "./MoreGame.vue?vue&type=script&lang=js"
import style0 from "./MoreGame.vue?vue&type=style&index=0&id=2d398fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d398fa8",
  null
  
)

export default component.exports